import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ZapIcon, LockIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="bg-white px-4 md:pt-32 md:pb-20 pt-[5px] pb-[5px]" data-id="element-140">
      <div className="max-w-[800px] mx-auto flex flex-col items-center text-center" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-142">
          <h1 className="font-heading font-bold md:text-4xl text-gray-900 mt-[-60px] mb-[-60px] text-[28px] pt-[80px] pb-[80px]" data-id="element-143">
            El Secreto para Comer{' '}
            <span className="text-[#00A86B]" data-id="element-144">Keto Rico</span>{' '}
            Sin Pasar Horas en la Cocina ni Gastar Fortuna en Delivery.
          </h1>

          <p className="md:text-base text-gray-500 max-w-2xl mx-auto text-[14px] mt-[8px] mb-[8px]" data-id="element-145">
            Conocé el{' '}
            <span className="text-[#00A86B] font-semibold" data-id="element-146">Recetario Keto para Air Fryer</span>{' '}
            que ya está ayudando a cientos de argentinas a bajar de peso comiendo rico todos los días, con{' '}
            <span className="text-[#00A86B] font-semibold" data-id="element-147">ingredientes del súper</span>,{' '}
            listas en 20 minutos y usando solo tu{' '}
            <span className="text-[#00A86B] font-semibold" data-id="element-148">Air Fryer</span>.
          </p>

          <div className="flex gap-2 mt-[10px] mb-[10px] flex-col items-center justify-center" data-id="element-149">
            <div className="flex text-[#F59E0B]" data-id="element-150">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-151" />)}
            </div>
            <span className="text-sm font-medium text-[#000000]" data-id="element-152">
              +200 personas usando el recetario
            </span>
          </div>

          <div className="w-full max-w-md mx-auto mb-6" data-id="element-153">
            <CTAButton data-id="element-154">QUIERO MIS RECETAS AHORA →</CTAButton>
          </div>

          <div className="flex flex-wrap justify-center gap-4 text-xs md:text-sm text-gray-600 font-medium mb-12" data-id="element-155">
            <div className="flex items-center gap-1" data-id="element-156">
              <ZapIcon className="w-4 h-4 text-[#00A86B]" data-id="element-157" />
              <span data-id="element-158">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-159">
              <LockIcon className="w-4 h-4 text-[#00A86B]" data-id="element-160" />
              <span data-id="element-161">Pago único</span>
            </div>
            <div className="flex items-center gap-1" data-id="element-162">
              <SmartphoneIcon className="w-4 h-4 text-[#00A86B]" data-id="element-163" />
              <span data-id="element-164">100% digital</span>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="w-full max-w-md mx-auto" data-id="element-165">
            <img src="https://cdn.magicpatterns.com/uploads/vojkkzrFJoNpJyGz41Ux8z/Gemini_Generated_Image_xml3dcxml3dcxml3_(1).png" alt="40 Recetas Keto en Air Fryer - Pack completo con ebook, celular y tablet" className="w-full h-auto rounded-2xl shadow-[0_8px_30px_rgba(0,168,107,0.25)]" data-id="element-166" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}